import { useNavigate } from "react-router-dom";
import { api, TOKEN_KEY } from "@/lib/api";

export const watchPath = (slug, episodeId) => (episodeId ? `/watch/${slug}/${episodeId}` : `/watch/${slug}`);

const EMPTY = { entries: [], resume: { episode_id: null, position: 0 } };

export async function resolveResume(slug) {
  if (!localStorage.getItem(TOKEN_KEY)) return EMPTY;
  try {
    const { data } = await api.get(`/watch/progress/${slug}`);
    return data;
  } catch {
    return EMPTY;
  }
}

export function usePlay() {
  const navigate = useNavigate();
  return async (slug) => {
    const { resume } = await resolveResume(slug);
    navigate(watchPath(slug, resume.episode_id));
  };
}
